import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"variable\":\"--font-body\",\"weight\":[\"400\",\"700\",\"800\"],\"display\":\"swap\",\"style\":[\"italic\",\"normal\"],\"subsets\":[\"latin\"]}],\"variableName\":\"BodyFont\"}");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/frontend/src/components/framework/CssLayout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/frontend/src/components/QueryWrapper.tsx");
